import { useEffect, useState } from "react";
import { getYear } from "date-fns";

import usePayroll from "../../hooks/usePayroll";

import { Box, Typography } from "@mui/material";

import Page from "./Page";
import Card from "../layout/Card";
import Select from "../elements/Select";

import PayPeriodModal from "../modals/PayPeriodModal";
import PayPeriods from "../ui/PayPeriods";

const Payroll = () => {
  const { getPayPeriods, payPeriods, fiscalYears, refreshPayPeriods } =
    usePayroll();

  const [openPayPeriodModal, setOpenPayPeriodModal] = useState(false);
  const [selectedPayPeriodId, setSelectedPayPeriodId] = useState(null);
  const [selectedFiscalYear, setSelectedFiscalYear] = useState(
    getYear(new Date())
  );

  const handleToolbarClick = (action) => {
    switch (action) {
    }
  };

  return (
    <>
      <Page
        pageName="payroll"
        includeToolbar={true}
        onToolItemClick={handleToolbarClick}
      >
        <PayPeriods />
      </Page>
    </>
  );
};

export default Payroll;
